import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsAcuity() {
    return <ComparisonPage slug="acuity" />;
}
